import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import './index.scss';
import Hero2 from '../../parts/Hero2/index';
import Timeline from '../../parts/Timeline';
import DataHero2 from '../../json/dataHero2.json';
import Card from '../../parts/Card/index';
import DataCard from '../../json/dataCard.json';

class Event extends Component{
    render() {
        return (
            <div>
                <Hero2 data={DataHero2}/>

                <div className="downArrow">&#8675;</div>
                <h2>Pemateri</h2>

                <div class="container-fluid">
                    <div class="scrolling-wrapper row flex-row flex-nowrap my-3 py-4">
                        <Card data={DataCard}/>
                        <Card data={DataCard}/>
                        <Card data={DataCard}/>
                        <Card data={DataCard}/>
                        <Card data={DataCard}/>
                        <Card data={DataCard}/>
                        <Card data={DataCard}/>
                    </div>
                </div>
                
                <h2 className="my-5">Timeline</h2>
                <Timeline /> 
            </div>
        )
    }
}

export default Event;